import { ScrollView } from 'devextreme-react';
import React, {useContext} from 'react';
import { StoreContext } from '../../contexts/store';
import styles from "./MainMenu.module.css";
import MenuGroup from "./menu-group";
const MainMenu = () => {
    
    const { menu_items } = useContext(StoreContext);
    return (
        <ScrollView height={window.innerHeight - 50} >
            <div className={styles.main_menu} style={{
                height: window.innerHeight - 50
            }}>
                {/* <MenuGroup key={0} group={{
                    items: [{
                        name: "",
                        icon: "fas fa-home",
                        path: "home"
                    }]
                }} /> */}
                {menu_items.map((x, idx) => {
                    return (
                        <MenuGroup key={idx} group={x} />
                    )
                })}
            </div>
        </ScrollView>
    );
};

export default MainMenu;